module.exports = __webpack_public_path__ + "static/media/aig.a308b282.png";